<template>
  <b-modal
    ref="objectDetailInfoWindowModal"
    centered
    title="Informacje o najbliższym obiekcie"
    :visible="objectDetailsWindowVisible"
    @hidden="hide"
  >
    <b-form>
      <fieldset>
        <div v-if="closestObjectInfo">
          <b-form-group
            v-for="(value, key) in closestObjectInfo.propertiesList"
            :key="key"
          >
            <b-form-row>
              <b-col md="6">
                <label class="col-form-label">{{ key }}</label>
              </b-col>
              <b-col md="6">
                <span class="form-text">{{ value || 'N/A' }}</span>
              </b-col>
            </b-form-row>
          </b-form-group>
        </div>

        <b-form-group label="Współrzędne">
          <b-form-row>
            <b-col md="6">
              <span class="form-text">{{
                closestObjectInfo && closestObjectInfo.coordinates
                  ? closestObjectInfo.coordinates[0]
                  : ''
              }}</span>
            </b-col>
            <b-col md="6">
              <span class="form-text">{{
                closestObjectInfo && closestObjectInfo.coordinates
                  ? closestObjectInfo.coordinates[1]
                  : ''
              }}</span>
            </b-col>
          </b-form-row>
        </b-form-group>
      </fieldset>
    </b-form>
    <div slot="modal-footer">
      <b-btn variant="outline-secondary" @click="hide">Zamknij</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { CLOSE_OBJECT_DETAILS_WINDOW } from '../store/mutations.type';

export default {
  name: 'objectDetailInfoWindow',
  computed: {
    ...mapGetters([
      'objectDetailsWindowVisible',
      'closestObjectInfo',
      'getReportingDemandEnabled'
    ])
  },
  methods: {
    hide() {
      this.$store.commit(CLOSE_OBJECT_DETAILS_WINDOW);
    }
  }
};
</script>
